<div class=" mt-4 p-5 card">
  <div class="row ">
    <div class="row card-title">
      <div class="col-md-12" >
        <div class="row items-direita">
          <div *ngIf="telaPequena" style="margin-top: -30px;font-size: 15px" class="col-md-12 titulo-dia text-center">
            <span class="fa fa-chevron-left" (click)="diminuirDia()"></span>
            {{diaTexto}} - {{mesTexto}}
            <span class="fa fa-chevron-right" (click)="adicionarDia()"></span>
          </div>
          <div class="col-md-6">
            <h4 class="text-lg-start">Minhas tarefas</h4>
          </div>
          <div *ngIf="!telaPequena" class="titulo-dia col-md-6">
            <span class="fa fa-chevron-left troca-dia" (click)="diminuirDia()"></span>
            Dia {{diaTexto}}
            <span class="fa fa-chevron-right troca-dia" (click)="adicionarDia()"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="timeline-dia calendario-container">
      <div *ngFor="let hora of horas">
        <div class="hora-label">{{ hora }}</div>
      </div>

      <div
        *ngFor="let event of events"
        class="event-block"
        [ngStyle]="getEventStyle(event)">
        {{ event.title }}<br />
        {{ event.start }} - {{ event.end }}
      </div>

      <div class="current-time-line" [style.top.px]="currentTimeTop"></div>
    </div>
  </div>
</div>
